import { DataObject } from '@/utils/DataObject'
import { Artwork } from './Artwork'
import { MediaTransformer } from '../media/MediaTransformer'
import { ArtistTransformer } from '../artist/ArtistTransformer'
import { GalleryTransformer } from '@/services/galleries/GalleryTransformer'

export class ArtworkTransformer {

  private parseMEdia (data: DataObject = {}) {

    // Media type is array for single artwork request
    if (data['media'] && data['media'] instanceof Array) {
      return data['media'].map((obj: DataObject) => new MediaTransformer().toClass(obj))
    }
    else {
      // Media is a object of primary image when in collection
      return new MediaTransformer().toClass(data['media'])
    }
  }

  private parseDimension (data: DataObject = {}): string | null {
    if (!data.height && !data.width && !data.depth) return null
    return `${data.height} x ${data.width} x ${data.depth} [cm]`
  }

  public toClass (data: DataObject = {}): Artwork {
    return new Artwork({
      id: data.id,
      title: data.title,
      slug: data.slug,
      description: data.description,
      category: data.category || {},
      technique: data.technique || {},
      price: data.price,
      createdYear: data.created_year,
      height: data.height,
      width: data.width,
      dimension: this.parseDimension(data),
      orientation: data.orientation,
      isFramed: !!data.is_framed,
      isForSale: !!data.is_for_sale,
      isHangReady: !!data.is_hang_ready,
      sizeRange: data.size_range,
      isOrderable: data.is_orderable,
      isTestable: data.is_testable,
      isPublished: data.is_published,
      media: this.parseMEdia(data),
      mediaCount: data.media_count,
      artist: data.artist ? new ArtistTransformer().toClass(data.artist) : undefined,
      views: data.views,
      likes_count: data.likes_count,
      hearts_count: data.hearts_count,
      surprises_count: data.surprises_count,
      favorites: data.favorites_count,
      favoriteId: data.favorite_id,
      path: data.path,
      is_in_gallery: data.is_in_gallery || false,
      is_suspended: data.is_suspended || false,
      virtual_exhibition: data.virtual_exhibition ? new GalleryTransformer().toClass(data.virtual_exhibition) : null,
      video_id: data.video_id,
      my_subscription_id: data.my_subscription_id || null,

      // VatAmount and VatRate is stored in localstorege and might be in different format
      vatAmount: data.vat_amount != null ? data.vat_amount : data.vatAmount,
      vatRate: data.vat_rate != null ? data.vat_rate : data.vatRate
    })
  }

}
